import ExportOverviewWidgetsActionComponent from "search/ExportWidgetAction/ExportOverviewWidgetsActionComponent";
import InvestigationsWidget from "security-app/components/Investigations/plugin/SearchWidgets/logic/InvestigationsWidget";
const ExportInvestigationsOverviewWidgetAction = {
  type: "export-investigation-overview-widget-action",
  position: "menu",
  isHidden: (w) => w.type !== InvestigationsWidget.type,
  component: ExportOverviewWidgetsActionComponent
};
export default ExportInvestigationsOverviewWidgetAction;
